// Export all services
export { default as layoutService } from '../layout-service.js';
export { default as authService } from './auth-service.js';
export { default as commonService } from './common-service.js';
export { default as companiesService } from './companies-service.js';
export { default as customerManagerService } from './customer-manager.js';
export { default as itemFilterService } from './item-filter-service.js';
export { default as itemRegisterFrameService } from './item-register-frame-service.js';
export { default as itemSearchService } from './item-search-service.js';
export { default as itemService } from './item-service.js';
export { default as postalCodeService } from './postal-code-service.js';
export { default as shippingRequestService } from './shipping-request-service.js';
export { default as staffManagementService } from './staff-management-service.js';
export { default as warehousesService } from './warehouses-service.js';

// Export all services as a single object for backward compatibility
import layoutService from '../layout-service.js';
import authService from './auth-service.js';
import commonService from './common-service.js';
import companiesService from './companies-service.js';
import customerManagerService from './customer-manager.js';
import itemFilterService from './item-filter-service.js';
import itemRegisterFrameService from './item-register-frame-service.js';
import itemSearchService from './item-search-service.js';
import itemService from './item-service.js';
import postalCodeService from './postal-code-service.js';
import shippingRequestService from './shipping-request-service.js';
import staffManagementService from './staff-management-service.js';
import warehousesService from './warehouses-service.js';

const request = {
    // Auth APIs
    checkLogin: authService.checkLogin,
    getEmailInfo: authService.getEmailInfo,
    login: authService.login,
    logout: authService.logout,
    forgotPassword: authService.forgotPassword,
    resetPassword: authService.resetPassword,
    registerPassword: authService.registerPassword,
    checkTokenExpired: authService.checkTokenExpired,

    // Layout APIs
    switchLayout: layoutService.switchLayout,

    // Common APIs
    getDeliveryCompanyList: commonService.getDeliveryCompanyList,
    getDataModalSearch: commonService.getDataModalSearch,
    getInfoCompany: commonService.getInfoCompany,
    getListCompany: commonService.getListCompany,
    getPrefList: commonService.getPrefList,

    // Postal Code APIs
    searchPostalCodes: postalCodeService.searchPostalCodes,
    getPostalCodeDetail: postalCodeService.getPostalCodeDetail,

    // Shipping Request APIs
    getShippingRequestList: shippingRequestService.getShippingRequestList,
    bulkRegisterShippingRequest: shippingRequestService.bulkRegisterShippingRequest,
    getShippingRequestDetail: shippingRequestService.getShippingRequestDetail,
    deleteShippingRequest: shippingRequestService.deleteShippingRequest,
    approveShippingRequest: shippingRequestService.approveShippingRequest,
    approveReturnRequest: shippingRequestService.approveReturnRequest,
    rejectReturnRequest: shippingRequestService.rejectReturnRequest,

    // Warehouse APIs
    getWarehouseList: warehousesService.getWarehouseList,
    getWarehouse: warehousesService.getWarehouse,
    updateWarehouse: warehousesService.updateWarehouse,
    deleteWarehouse: warehousesService.deleteWarehouse,

    // Staff Management APIs
    getStaffManagementList: staffManagementService.getStaffManagementList,
    insertStaff: staffManagementService.insertStaff,
    deleteStaff: staffManagementService.deleteStaff,
    editStaff: staffManagementService.editStaff,
    getStaffInfoEdit: staffManagementService.getStaffInfoEdit,

    // Company APIs
    getCompanyList: companiesService.getCompanyList,

    // Customer Management APIs
    getCustomerManagerList: customerManagerService.getCustomerManagerList,
    insertCustomerManager: customerManagerService.insertCustomerManager,
    setCompany: customerManagerService.setCompany,
    updateCustomerCompany: customerManagerService.updateCustomerCompany,

    // Item APIs
    fetchItems: itemService.fetchItems,
    fetchItemById: itemService.fetchItemById,
    updateItem: itemService.updateItem,
    deleteItem: itemService.deleteItem,
    addItem: itemService.addItem,
    createStockProduct: itemService.createStockProduct,
    exportItemsToCSV: itemService.exportItemsToCSV,
    exportItemsToExcel: itemService.exportItemsToExcel,
    getItemStatistics: itemService.getItemStatistics,
    workRequest: itemService.workRequest,
    storageExtensionRequest: itemService.storageExtensionRequest,
    processRequest: itemService.processRequest,
    // Item Filter APIs
    applyStatusFilter: itemFilterService.applyStatusFilter,
    applyTypeFilter: itemFilterService.applyTypeFilter,
    applyStockFilter: itemFilterService.applyStockFilter,
    applyPriceFilter: itemFilterService.applyPriceFilter,
    applyDateFilter: itemFilterService.applyDateFilter,
    applyAllFilters: itemFilterService.applyAllFilters,
    getFilterSummary: itemFilterService.getFilterSummary,
    clearAllFilters: itemFilterService.clearAllFilters,
    getFilterOptions: itemFilterService.getFilterOptions,

    // Item Search APIs
    searchItems: itemSearchService.searchItems,
    advancedSearch: itemSearchService.advancedSearch,
    getAutocompleteSuggestions: itemSearchService.getAutocompleteSuggestions,
    searchWithFilters: itemSearchService.searchWithFilters,
    // Item Register Frame APIs
    getItemRegisterFrameList: itemRegisterFrameService.getItemRegisterFrameList,
    uploadItemRegisterFrame: itemRegisterFrameService.uploadItemRegisterFrame
};

export default request;
